module.exports = __webpack_public_path__ + "img/alkis.1b82e9fe.png";